import { call, put, select, takeLatest, delay } from 'redux-saga/effects';

import {
	getPurchases,
	getPurchasesFailure,
	getPurchasesSuccess,
	getPurchaseById,
	getPurchaseByIdFailure,
	getPurchaseByIdSuccess,
	getPurchaseStatuses,
	getPurchaseStatusesFailure,
	getPurchaseStatusesSuccess,
} from '.';

import purchaseService from '../../../services/PurchaseService';

function* rootSaga() {
	yield takeLatest(getPurchases, getPurchasesSaga);
	yield takeLatest(getPurchaseById, getPurchaseByIdSaga);
	yield takeLatest(getPurchaseStatuses, getPurchaseStatusesSaga);
}

function* getPurchasesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(purchaseService.getAll, payload);
		yield put(getPurchasesSuccess(response));
	} catch (error) {
		yield put(getPurchasesFailure(error));
	}
}

function* getPurchaseByIdSaga({ payload }) {
	const purchaseId = payload;
	try {
		yield delay(300);
		const response = yield call(purchaseService.get, purchaseId);
		yield put(getPurchaseByIdSuccess(response));
	} catch (error) {
		yield put(getPurchaseByIdFailure(error));
	}
}

function* getPurchaseStatusesSaga({ payload }) {
	try {
		yield delay(300);
		const response = yield call(purchaseService.getStatuses);
		yield put(getPurchaseStatusesSuccess(response));
	} catch (error) {
		yield put(getPurchaseStatusesFailure(error));
	}
}

export default rootSaga;
